import React, { useState } from "react";
import { motion } from "framer-motion";
import { footerVariants } from "../utils/motion";

const API_BASE = (
  process.env.REACT_APP_ATAFRICA_API_URL || "http://localhost:2000"
).replace(/\/$/, "");

const Footer = ({ home }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const handleSubscribe = async (event) => {
    event.preventDefault();
    setError("");
    setStatus("loading");
    try {
      const response = await fetch(`${API_BASE}/api/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), source: "qpafrica" }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setError(data.msg || data.message || "Subscription failed");
        setStatus("idle");
        return;
      }
      setEmail("");
      setStatus("done");
    } catch {
      setError("Subscription failed");
      setStatus("idle");
    }
  };

  return (
    <motion.div
      variants={footerVariants}
      initial="hidden"
      whileInView="show"
      className={`${home ? "absolute bottom-0 w-full" : ""} bg-black`}
    >
      <footer className="flex flex-col items-center gap-4 text-gray-300 py-6 px-4">
        <div className="w-full max-w-sm">
          {status === "done" ? (
            <p className="text-sm text-center text-green-400">
              Thanks — you&apos;re subscribed.
            </p>
          ) : (
            <form
              onSubmit={handleSubscribe}
              className="flex flex-col sm:flex-row gap-2"
            >
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Subscribe with your email"
                className="min-w-0 flex-1 rounded-lg bg-gray-700 p-3 text-sm text-gray-300 focus:outline-none"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="rounded-lg bg-blue-700 px-4 py-3 text-sm font-bold text-white disabled:opacity-60"
              >
                {status === "loading" ? "..." : "Subscribe"}
              </button>
            </form>
          )}
          {error ? (
            <p className="mt-2 text-center text-xs text-red-400">{error}</p>
          ) : null}
        </div>
        <p className="text-sm">All Rights Reserved © {new Date().getFullYear()} QPAfrica.</p>
      </footer>
    </motion.div>
  );
};

export default Footer;
